<template>
  <section>
    <div class="columns is-marginless is-paddingless">
      <div class="column is-5 has-background-white is-paddingless is-secondary-content">
        <div class="hero is-secondary-content">
          <router-view/>
        </div>
      </div>
      <div class="column is-paddingless">
        <div class="hero is-secondary-content is-relative">
          <carte></carte>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Carte from '../../components/recommandation/carte.vue'

export default {
  components: { Carte },
};
</script>

<style>

</style>
